export default function noop(..._: any[]): void {
  /* noop */
}
